import getDefaultState from './defaultState';

export default getDefaultState();



// WEBPACK FOOTER //
// ./src/store/modules/ski/areas/state.js